import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Copyright from 'components/Copyright/Copyright';
import smallLogo from 'assets/images/logos/Prevail Logo Dark Small.png';
import {Link} from 'react-router-dom';
import { LinkedIn,Twitter } from "@mui/icons-material";

export default function Footer() {
    return(
            <Grid container 
                sx={{
                    placeItems: "center",
                    background: 'linear-gradient( #393939, #202020)',
                    zIndex: 10,
                    position: "relative",
                    justifyContent: "center"
                }} >
                <Grid  >
                    <Box minHeight="20rem" 
                    >
                        <Grid container maxWidth="lg" spacing={2} ml={5} mt={10} >
                            <Grid item size={{ xs: 12, md: 4}}>
                                <Grid container>
                                    <Grid item size={12}>
                                        <Link to="/" >
                                            <img src={smallLogo} width={"200px"} />
                                        </Link>
                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 8}} >
                                                <Typography variant="caption" color="grey.300">
                                                    Prevail Cybersecurity is bringing intelligent threat detection to Microsoft 365, to quickly end unauthorized access to Email, Teams, SharePoint, and other Azure services.
                                                </Typography>
                                        
                                    </Grid>
                                    <Grid item size={12} mt={2}>
                                        <Link to="https://twitter.com/trawlai" target="_blank"><Typography mr={2} color="grey.300" variant="caption"><Twitter /></Typography></Link>
                                        <Link to="https://www.linkedin.com/company/trawl-ai/" target="_blank"><Typography color="grey.300" variant="caption"><LinkedIn /></Typography></Link>
                                        
                                    </Grid>
                                </Grid>
    
                            </Grid>
                            <Grid item size={{ xs: 12, md: 2 }} mt={{ xs: 6, md: 5}}>
                                <Typography variant="body1"  color="grey.300">Platform</Typography>
                                <Typography component={Link} color="grey.300" display="block" style={{ textDecoration: 'none'}} to="/products/ms365" variant="caption" >Microsoft 365</Typography>
                                <Typography component={Link} color="grey.300" display="block" style={{ textDecoration: 'none'}} to="/products/workspace" variant="caption" >Google Workspace</Typography>
                                <Typography component={Link} color="grey.300" display="block" style={{ textDecoration: 'none'}} to="/products/siem" variant="caption" >SIEM</Typography>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 2 }} mt={{ xs: 6, md: 5}}>
                                <Typography variant="body1"  color="grey.300">About</Typography>
                                <Typography component={Link} color="grey.300" display="block" style={{ textDecoration: 'none'}} to="/about" variant="caption" >About Prevail</Typography>
                                <Typography component={Link} color="grey.300" display="block" style={{ textDecoration: 'none'}} to="/contact-us" variant="caption" >Contact Us</Typography>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 2 }} mt={{ xs: 6, md: 5}}>
                                <Typography variant="body1" color="grey.300">Who We Serve</Typography>
                                <Typography component={Link} color="grey.300" display="block" style={{ textDecoration: 'none'}} to="/managed-partners" variant="caption" >Managed Services Providers</Typography>
                                <Typography component={Link} color="grey.300" display="block" style={{ textDecoration: 'none'}} to="/smb" variant="caption" >Small & Medium Businesses</Typography>
                            </Grid>
                            <Grid item size={{ xs: 12, md: 2 }} mt={{ xs: 6, md: 5}}>
                                <Typography variant="body1"  color="grey.300" style={{ textDecoration: 'none'}} component={Link} to="/blog">Blog</Typography>
                            </Grid>
                            <Grid item size={12} mt={{ xs: 6, md: 10}}>
                                <Copyright />
                            </Grid>
                        </Grid> 
                    </Box>
                </Grid>
            </Grid>
    );
}